import { createContext } from 'react';
export const CellSelectionStoreContext = /*#__PURE__*/createContext(undefined);